const SearchActionTypes = {
  SET_ATTRACTION_ID: 'SET_ATTRACTION_ID',
  SET_LANG: 'SET_LANG',
  SET_SALE_CUR: 'SET_SALE_CUR',
  RESET: 'RESET',
};

export default SearchActionTypes;
